export const RQ_CREATE_LEAVE_API = {
  url: 'leaves/createLeave',
  method: 'PUT',
  auth: true,
};
